// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
import DocumentFormController from "./document_form_controller"
import ClientSearchController from "./client_search_controller"
import WhatsappSendController from "./whatsapp_send_controller"
import NestedFormController from "./nested_form_controller"

application.register("hello", HelloController)
application.register("document-form", DocumentFormController)
application.register("client-search", ClientSearchController)
application.register("whatsapp-send", WhatsappSendController)
application.register("nested-form", NestedFormController)
